<template>
  <div>
    <section class="section pb-none">
      <the-search />
    </section>

    <section class="section">
      <div class="container">
        <h1 class="title is-5 is-uppercase" v-t="'title'" />

        <div class="columns">
          <div class="column is-7">
            <div class="box">
              <h2 class="title is-5" v-t="'articles_title'" />
              <article-search-results :term="searchTerm" />
            </div>
          </div>

          <div class="column is-5">
            <div class="box">
              <h2 class="title is-5" v-t="'questions_title'" />
              <question-search-results :term="searchTerm" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TheSearch from '@/components/TheSearch'
import ArticleSearchResults from '@/components/ArticleSearchResults'
import QuestionSearchResults from '@/components/QuestionSearchResults'

export default {
  name: 'SearchResults',
  components: {
    TheSearch,
    ArticleSearchResults,
    QuestionSearchResults
  },
  computed: {
    searchTerm () {
      return this.$route.query.term
    }
  },
  metaInfo () {
    return { title: this.$t('title') }
  }
}
</script>

<i18n>
{
  "en-US": {
    "title": "Search Results",
    "articles_title": "Articles",
    "questions_title": "Frequently Asked Questions"
  },
  "pt-BR": {
    "title": "Resultado da Pesquisa",
    "articles_title": "Artigos",
    "questions_title": "Dúvidas Frequentes / FAQ"
  }
}
</i18n>
